import { defineSlotRecipe } from '@chakra-ui/react';
import { drawerAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: drawerAnatomy.keys(),
  base: {
    body: {
      pb: 6,
      pt: 6,
    },
    closeTrigger: {
      fontSize: 'lg',
      top: 4,
    },
    content: {
      paddingInlineEnd: 5,
      paddingInlineStart: 5,
    },
    footer: {
      pb: 5,
      pt: 5,
    },
    header: {
      fontWeight: 'bold',
      paddingInlineEnd: 12,
    },
  },
});
